!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("prop-types"), require("react")) : "function" == typeof define && define.amd ? define(["prop-types", "react"], t) : "object" == typeof exports ? exports.ReactSVGPanZoom = t(require("prop-types"), require("react")) : e.ReactSVGPanZoom = t(e.PropTypes, e.React);
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    window, e.exports = function (e) {
      var t = {};
      function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
      }
      return n.m = e, n.c = t, n.d = function (e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: r
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var o in e) n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
        return r;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 0);
    }([function (e, t, n) {
      "use strict";

      function r(e, t) {
        return {
          x: e.a * t.x + e.c * t.y + e.e,
          y: e.b * t.x + e.d * t.y + e.f
        };
      }
      function o(e, t) {
        return t.map(function (t) {
          return r(e, t);
        });
      }
      function i(e) {
        return {
          a: parseFloat(e.a),
          b: parseFloat(e.b),
          c: parseFloat(e.c),
          d: parseFloat(e.d),
          e: parseFloat(e.e),
          f: parseFloat(e.f)
        };
      }
      n.r(t);
      var a = /^matrix\(\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*\)$/i;
      function u(e) {
        var t = e.match(a);
        if (null === t || t.length < 7) throw new Error("'" + e + "' is not a matrix");
        return {
          a: parseFloat(t[1]),
          b: parseFloat(t[2]),
          c: parseFloat(t[3]),
          d: parseFloat(t[4]),
          e: parseFloat(t[5]),
          f: parseFloat(t[6])
        };
      }
      function c() {
        return {
          a: 1,
          c: 0,
          e: 0,
          b: 0,
          d: 1,
          f: 0
        };
      }
      function l(e) {
        var t = e.a,
          n = e.b,
          r = e.c,
          o = e.d,
          i = e.e,
          a = e.f,
          u = t * o - n * r;
        return {
          a: o / u,
          b: n / -u,
          c: r / -u,
          d: t / u,
          e: (o * i - r * a) / -u,
          f: (n * i - t * a) / u
        };
      }
      var s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
          return typeof e;
        } : function (e) {
          return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        },
        f = function f(e) {
          return "number" == typeof e && !isNaN(e) && isFinite(e);
        },
        h = function h(e) {
          return null != e && "object" === (void 0 === e ? "undefined" : s(e));
        };
      function d(e) {
        return h(e) && e.hasOwnProperty("a") && f(e.a) && e.hasOwnProperty("b") && f(e.b) && e.hasOwnProperty("c") && f(e.c) && e.hasOwnProperty("d") && f(e.d) && e.hasOwnProperty("e") && f(e.e) && e.hasOwnProperty("f") && f(e.f);
      }
      function p(e) {
        return void 0 === e;
      }
      function v(e) {
        return {
          a: 1,
          c: 0,
          e: e,
          b: 0,
          d: 1,
          f: arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0
        };
      }
      function g() {
        for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) t[n] = arguments[n];
        var r = function r(e, t) {
          return {
            a: e.a * t.a + e.c * t.b,
            c: e.a * t.c + e.c * t.d,
            e: e.a * t.e + e.c * t.f + e.e,
            b: e.b * t.a + e.d * t.b,
            d: e.b * t.c + e.d * t.d,
            f: e.b * t.e + e.d * t.f + e.f
          };
        };
        switch ((t = Array.isArray(t[0]) ? t[0] : t).length) {
          case 0:
            throw new Error("no matrices provided");
          case 1:
            return t[0];
          case 2:
            return r(t[0], t[1]);
          default:
            var o = function (e) {
                return Array.isArray(e) ? e : Array.from(e);
              }(t),
              i = o[0],
              a = o[1],
              u = o.slice(2),
              c = r(i, a);
            return g.apply(void 0, [c].concat(function (e) {
              if (Array.isArray(e)) {
                for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
                return n;
              }
              return Array.from(e);
            }(u)));
        }
      }
      var m = Math.cos,
        b = Math.sin,
        y = Math.PI;
      function O(e, t, n) {
        var r = m(e),
          o = b(e),
          i = {
            a: r,
            c: -o,
            e: 0,
            b: o,
            d: r,
            f: 0
          };
        return p(t) || p(n) ? i : g([v(t, n), i, v(-t, -n)]);
      }
      function w(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0;
        return O(e * y / 180, t, n);
      }
      function V(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
        return p(t) && (t = e), {
          a: e,
          c: 0,
          e: 0,
          b: 0,
          d: t,
          f: 0
        };
      }
      function x(e, t) {
        return {
          a: 1,
          c: e,
          e: 0,
          b: t,
          d: 1,
          f: 0
        };
      }
      function P(e) {
        return E(e);
      }
      function M(e) {
        return E(e);
      }
      function E(e) {
        return "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")";
      }
      n.d(t, "applyToPoint", function () {
        return r;
      }), n.d(t, "applyToPoints", function () {
        return o;
      }), n.d(t, "fromObject", function () {
        return i;
      }), n.d(t, "fromString", function () {
        return u;
      }), n.d(t, "identity", function () {
        return c;
      }), n.d(t, "inverse", function () {
        return l;
      }), n.d(t, "isAffineMatrix", function () {
        return d;
      }), n.d(t, "rotate", function () {
        return O;
      }), n.d(t, "rotateDEG", function () {
        return w;
      }), n.d(t, "scale", function () {
        return V;
      }), n.d(t, "shear", function () {
        return x;
      }), n.d(t, "toCSS", function () {
        return P;
      }), n.d(t, "toSVG", function () {
        return M;
      }), n.d(t, "toString", function () {
        return E;
      }), n.d(t, "transform", function () {
        return g;
      }), n.d(t, "translate", function () {
        return v;
      });
    }]);
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(1),
      o = n.n(r),
      i = n(0),
      a = n.n(i),
      u = n(2),
      c = "idle",
      l = "panning",
      s = "zooming",
      f = "auto",
      h = "none",
      d = "pan",
      p = "zoom-in",
      v = "zoom-out",
      g = "top",
      m = "right",
      b = "bottom",
      y = "left",
      O = "zoom",
      w = "pan",
      V = "center",
      x = "left",
      P = "right",
      M = "top",
      E = "bottom",
      j = ("function" == typeof Symbol && Symbol.iterator, Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      });
    function k(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
      return e = Object.assign({}, e, t, {
        lastAction: n
      }), Object.freeze(e);
    }
    function S(e, t, n) {
      var r = Object(u.fromObject)(e),
        o = Object(u.inverse)(r);
      return Object(u.applyToPoint)(o, {
        x: t,
        y: n
      });
    }
    function T(e) {
      var t = Object(u.fromObject)(e);
      return {
        scaleFactor: t.a,
        translationX: t.e,
        translationY: t.f
      };
    }
    function _(e, t, n, r) {
      var o = e.viewerWidth,
        i = e.viewerHeight,
        a = Object(u.transform)(Object(u.translate)(o / 2 - t, i / 2 - n), Object(u.translate)(t, n), Object(u.scale)(r, r), Object(u.translate)(-t, -n));
      return k(e, j({
        mode: c
      }, a));
    }
    function C(e) {
      return k(e, j({
        mode: c
      }, Object(u.identity)()));
    }
    function R(e) {
      return k(e, {
        mode: c,
        startX: null,
        startY: null,
        endX: null,
        endY: null
      });
    }
    var F = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();
    var G = function () {
        function e(t, n, r) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.originalEvent = t, this.value = n, this.SVGViewer = r;
        }
        return F(e, [{
          key: "preventDefault",
          value: function value() {
            this.originalEvent.preventDefault();
          }
        }, {
          key: "stopPropagation",
          value: function value() {
            this.originalEvent.stopPropagation();
          }
        }, {
          key: "scaleFactor",
          get: function get() {
            return this._cacheDecomposedValue = this._cacheDecomposedValue || T(this.value), this._cacheDecomposedValue.scaleFactor;
          }
        }, {
          key: "translationX",
          get: function get() {
            return this._cacheDecomposedValue = this._cacheDecomposedValue || T(this.value), this._cacheDecomposedValue.translationX;
          }
        }, {
          key: "translationY",
          get: function get() {
            return this._cacheDecomposedValue = this._cacheDecomposedValue || T(this.value), this._cacheDecomposedValue.translationY;
          }
        }]), e;
      }(),
      Y = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    var D = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, G), Y(t, [{
          key: "point",
          get: function get() {
            if (!this._cachePoint) {
              var e = this.originalEvent,
                t = this.value,
                n = this.SVGViewer.getBoundingClientRect(),
                r = e.clientX - Math.round(n.left),
                o = e.clientY - Math.round(n.top);
              this._cachePoint = S(t, r, o);
            }
            return this._cachePoint;
          }
        }, {
          key: "x",
          get: function get() {
            return this.point.x;
          }
        }, {
          key: "y",
          get: function get() {
            return this.point.y;
          }
        }]), t;
      }(),
      X = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      q = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    var L = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, G), q(t, [{
          key: "points",
          get: function get() {
            return this._cachePoints || (this._cachePoints = t.touchesToPoints(this.originalEvent.touches, this.SVGViewer, this.value)), this._cachePoints;
          }
        }, {
          key: "changedPoints",
          get: function get() {
            return this._cacheChangedPoints || (this._cacheChangedPoints = t.touchesToPoints(this.originalEvent.changedTouches, this.SVGViewer, this.value)), this._cacheChangedPoints;
          }
        }], [{
          key: "touchesToPoints",
          value: function value(e, t, n) {
            for (var r = [], o = 0; o < e.length; o++) {
              var i = e[o],
                a = t.getBoundingClientRect(),
                u = S(n, i.clientX - Math.round(a.left), i.clientY - Math.round(a.top));
              r.push(X({}, u, {
                identifier: i.identifier
              }));
            }
            return r;
          }
        }]), t;
      }(),
      A = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      H = function () {
        return function (e, t) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function (e, t) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                !r && u.return && u.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }(e, t);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }();
    function W(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : void 0,
        o = Object(u.transform)(Object(u.fromObject)(e), Object(u.translate)(t, n));
      if (r) {
        var i = Object(u.applyToPoints)(o, [{
            x: r,
            y: r
          }, {
            x: e.SVGWidth - r,
            y: e.SVGHeight - r
          }]),
          a = H(i, 2),
          l = a[0],
          s = l.x,
          f = l.y,
          h = a[1],
          d = h.x,
          p = h.y,
          v = 0;
        e.viewerWidth - s < 0 ? v = e.viewerWidth - s : d < 0 && (v = -d);
        var g = 0;
        e.viewerHeight - f < 0 ? g = e.viewerHeight - f : p < 0 && (g = -p), o = Object(u.transform)(Object(u.translate)(v, g), o);
      }
      return k(e, A({
        mode: c
      }, o), w);
    }
    function z(e) {
      return k(e, {
        mode: c,
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }, w);
    }
    function N(e, t) {
      return e.x <= t.x && e.y <= t.y ? {
        x: e.x,
        y: e.y,
        width: t.x - e.x,
        height: t.y - e.y
      } : e.x >= t.x && e.y <= t.y ? {
        x: t.x,
        y: e.y,
        width: e.x - t.x,
        height: t.y - e.y
      } : e.x >= t.x && e.y >= t.y ? {
        x: t.x,
        y: t.y,
        width: e.x - t.x,
        height: e.y - t.y
      } : e.x <= t.x && e.y >= t.y ? {
        x: e.x,
        y: t.y,
        width: t.x - e.x,
        height: e.y - t.y
      } : void 0;
    }
    var I = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    function B(e, t) {
      return function (e, t) {
        return e.scaleFactorMin && e.d * t <= e.scaleFactorMin;
      }(e, t) && t < 1 || function (e, t) {
        return e.scaleFactorMax && e.d * t >= e.scaleFactorMax;
      }(e, t) && t > 1;
    }
    function Z(e, t) {
      var n = t.a;
      return null != e.scaleFactorMin && (n = Math.max(n, e.scaleFactorMin)), null != e.scaleFactorMax && (n = Math.min(n, e.scaleFactorMax)), k(t, {
        a: n,
        d: n
      });
    }
    function U(e, t, n, r) {
      if (B(e, r)) return e;
      var o = Object(u.transform)(Object(u.fromObject)(e), Object(u.translate)(t, n), Object(u.scale)(r, r), Object(u.translate)(-t, -n));
      return k(e, I({
        mode: c
      }, Z(e, o), {
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }), O);
    }
    function K(e, t, n, r, o) {
      var i = e.viewerWidth / r,
        a = e.viewerHeight / o,
        l = Math.min(i, a),
        s = Object(u.transform)(Object(u.scale)(l, l), Object(u.translate)(-t, -n));
      return B(e, l / e.d) ? k(e, {
        mode: c,
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }) : k(e, I({
        mode: c
      }, Z(e, s), {
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }), O);
    }
    function $(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : x,
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : M,
        r = e.viewerWidth,
        o = e.viewerHeight,
        i = e.SVGWidth,
        a = e.SVGHeight,
        l = r / i,
        s = o / a,
        f = Math.min(l, s),
        h = Object(u.scale)(f, f),
        d = Object(u.translate)(0, 0);
      if (l < s) {
        var p = o - l * a;
        n === V && (d = Object(u.translate)(0, Math.round(p / 2))), n === E && (d = Object(u.translate)(0, p));
      } else {
        var v = r - s * i;
        t === V && (d = Object(u.translate)(Math.round(v / 2), 0)), t === P && (d = Object(u.translate)(v, 0));
      }
      var g = Object(u.transform)(d, h);
      return B(e, f / e.d) ? k(e, {
        mode: c,
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }) : k(e, I({
        mode: c
      }, Z(e, g), {
        startX: null,
        startY: null,
        endX: null,
        endY: null
      }), O);
    }
    function J(e, t) {
      var n = S(e, e.viewerWidth / 2, e.viewerHeight / 2);
      return U(e, n.x, n.y, t);
    }
    function Q(e, t, n, r, o) {
      var i = e.startX,
        a = e.startY,
        u = e.endX,
        c = e.endY,
        l = S(e, i, a),
        s = S(e, u, c);
      if (Math.abs(i - u) > 7 && Math.abs(a - c) > 7) {
        var f = N(l, s);
        return K(e, f.x, f.y, f.width, f.height);
      }
      var h = S(e, t, n);
      return U(e, h.x, h.y, r);
    }
    function ee(e, t, n, r, o) {
      var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        a = void 0,
        u = void 0;
      if (i) a = i.x, u = i.y;else {
        var c = t.getBoundingClientRect(),
          h = c.left,
          g = c.top;
        a = e.clientX - Math.round(h), u = e.clientY - Math.round(g);
      }
      var m = r;
      switch (n) {
        case v:
          var b = S(r, a, u);
          m = U(r, b.x, b.y, 1 / o.scaleFactor);
          break;
        case p:
          m = function (e, t, n) {
            return k(e, {
              mode: s,
              startX: t,
              startY: n,
              endX: t,
              endY: n
            });
          }(r, a, u);
          break;
        case f:
        case d:
          m = function (e, t, n) {
            return k(e, {
              mode: l,
              startX: t,
              startY: n,
              endX: t,
              endY: n
            }, w);
          }(r, a, u);
          break;
        default:
          return r;
      }
      return e.preventDefault(), m;
    }
    function te(e, t, n, r, o) {
      var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        a = void 0,
        u = void 0;
      if (i) a = i.x, u = i.y;else {
        var c = t.getBoundingClientRect(),
          h = c.left,
          v = c.top;
        a = e.clientX - Math.round(h), u = e.clientY - Math.round(v);
      }
      var g = 0 === e.buttons,
        m = r;
      switch (n) {
        case p:
          r.mode === s && (m = g ? Q(r, a, u, o.scaleFactor) : function (e, t, n) {
            if (e.mode !== s) throw new Error("update selection not allowed in this mode " + e.mode);
            return k(e, {
              endX: t,
              endY: n
            });
          }(r, a, u));
          break;
        case f:
        case d:
          r.mode === l && (m = g ? z(r) : function (e, t, n, r) {
            if (e.mode !== l) throw new Error("update pan not allowed in this mode " + e.mode);
            var o = S(e, e.endX, e.endY),
              i = S(e, t, n);
            return k(W(e, i.x - o.x, i.y - o.y, r), {
              mode: l,
              endX: t,
              endY: n
            }, w);
          }(r, a, u, o.preventPanOutside ? 20 : void 0));
          break;
        default:
          return r;
      }
      return e.preventDefault(), m;
    }
    function ne(e, t, n, r, o) {
      var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        a = void 0,
        u = void 0;
      if (i) a = i.x, u = i.y;else {
        var c = t.getBoundingClientRect(),
          h = c.left,
          g = c.top;
        a = e.clientX - Math.round(h), u = e.clientY - Math.round(g);
      }
      var m = r;
      switch (n) {
        case v:
          r.mode === s && (m = Q(r, a, u, 1 / o.scaleFactor));
          break;
        case p:
          r.mode === s && (m = Q(r, a, u, o.scaleFactor));
          break;
        case f:
        case d:
          r.mode === l && (m = z(r));
          break;
        default:
          return r;
      }
      return e.preventDefault(), m;
    }
    function re(e, t, n, r, o) {
      arguments.length > 5 && void 0 !== arguments[5] && arguments[5];
      var i = function (e, t) {
        return k(e, {
          focus: t
        });
      }(r, "mouseenter" === e.type);
      return e.preventDefault(), i;
    }
    function oe(e, t, n, r, o) {
      var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
        a = i.x,
        u = i.y;
      return [h, f].indexOf(n) >= 0 && o.detectAutoPan && r.focus ? function (e, t, n) {
        var r = 0,
          o = 0;
        return n <= 20 && (o = 2), e.viewerWidth - t <= 20 && (r = -2), e.viewerHeight - n <= 20 && (o = -2), t <= 20 && (r = 2), r /= e.d, o /= e.d, 0 === r && 0 === o ? e : W(e, r, o);
      }(r, a, u) : r;
    }
    var ie = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    };
    function ae(e) {
      return "number" == typeof e.pinchPointDistance;
    }
    function ue(e, t, n, r, o) {
      var i = t.getBoundingClientRect(),
        a = i.left,
        c = i.top,
        l = e.touches[0].clientX - Math.round(a),
        f = e.touches[0].clientY - Math.round(c),
        h = e.touches[1].clientX - Math.round(a),
        d = e.touches[1].clientY - Math.round(c),
        p = Math.sqrt(Math.pow(h - l, 2) + Math.pow(d - f, 2)),
        v = ae(r) ? r.pinchPointDistance : p,
        g = S(r, (l + h) / 2, (f + d) / 2),
        m = p / v;
      if (B(r, m)) return r;
      e.cancelable && e.preventDefault();
      var b = Object(u.transform)(Object(u.fromObject)(r), Object(u.translate)(g.x, g.y), Object(u.scale)(m, m), Object(u.translate)(-g.x, -g.y));
      return k(r, k(ie({
        mode: s
      }, Z(r, b), {
        startX: null,
        startY: null,
        endX: null,
        endY: null,
        prePinchMode: r.prePinchMode ? r.prePinchMode : r.mode,
        pinchPointDistance: p
      })));
    }
    function ce(e, t) {
      return t.detectPinchGesture && e.touches.length > 1;
    }
    function le(e, t, n, r, o, i) {
      var a = 0 === e.touches.length ? k(r, {
          mode: r.prePinchMode ? c : r.mode,
          prePinchMode: null
        }) : r,
        u = function (e, t) {
          var n = t.getBoundingClientRect(),
            r = n.left,
            o = n.top;
          return {
            x: e.clientX - Math.round(r),
            y: e.clientY - Math.round(o)
          };
        }(e.touches.length > 0 ? e.touches[0] : e.changedTouches[0], t);
      switch (n) {
        case v:
        case p:
        case f:
        case d:
          return e.stopPropagation(), e.preventDefault(), i(e, t, n, a, o, u);
        default:
          return a;
      }
    }
    function se(e, t, n, r, o) {
      if (!([l, s].indexOf(r.mode) >= 0)) return r;
      var i = function (e, t, n) {
        return n.detectPinchGesture && ae(t) && e.touches.length < 2;
      }(e, r, o) ? k(r, {
        pinchPointDistance: null
      }) : r;
      return e.touches.length > 0 ? i : le(e, t, n, i, o, ne);
    }
    function fe(e) {
      return k(e, {
        miniatureOpen: !0
      });
    }
    function he(e) {
      return k(e, {
        miniatureOpen: !1
      });
    }
    var de = function de() {
        return navigator.userAgent.toLowerCase();
      },
      pe = function pe(e) {
        return function (e) {
          return ["zoom-in", "zoom-out", "grab", "grabbing"].indexOf(e) > -1;
        }(e) ? de().indexOf("firefox") > -1 ? "-moz-" + e : de().indexOf("webkit") > -1 ? "-webkit-" + e : void 0 : e;
      };
    var ve = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      ge = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    var me = 1,
      be = function be() {
        return "uid" + me++;
      };
    function ye(e) {
      var t = function (t) {
        function n(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, n);
          var t = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (n.__proto__ || Object.getPrototypeOf(n)).call(this, e));
          return t.state = {
            uid: be()
          }, t;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(n, o.a.Component), ge(n, [{
          key: "render",
          value: function value() {
            return o.a.createElement(e, ve({
              _uid: this.state.uid
            }, this.props));
          }
        }]), n;
      }();
      return t.displayName = "RandomUID(" + function (e) {
        return e.displayName || e.name || "Component";
      }(e) + ")", t;
    }
    var Oe = "react-svg-pan-zoom_border_gradient";
    function we(e) {
      var t = e.direction,
        n = e.width,
        r = e.height,
        i = e._uid,
        a = void 0;
      switch (t) {
        case g:
          a = "translate(" + n + ", 0) rotate(90)";
          break;
        case m:
          a = "translate(" + n + ", " + r + ") rotate(180)";
          break;
        case b:
          a = "translate(0, " + r + ") rotate(270)";
          break;
        case y:
          a = " ";
      }
      var u = Oe + "_gradient_" + i,
        c = Oe + "_mask_" + i;
      return o.a.createElement("g", null, o.a.createElement("defs", null, o.a.createElement("linearGradient", {
        id: u,
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "0%",
        spreadMethod: "pad"
      }, o.a.createElement("stop", {
        offset: "0%",
        stopColor: "#fff",
        stopOpacity: "0.8"
      }), o.a.createElement("stop", {
        offset: "100%",
        stopColor: "#000",
        stopOpacity: "0.5"
      })), o.a.createElement("mask", {
        id: c,
        x: "0",
        y: "0",
        width: "20",
        height: Math.max(n, r)
      }, o.a.createElement("rect", {
        x: "0",
        y: "0",
        width: "20",
        height: Math.max(n, r),
        style: {
          stroke: "none",
          fill: "url(#" + u + ")"
        }
      }))), o.a.createElement("rect", {
        x: "0",
        y: "0",
        width: "20",
        height: Math.max(n, r),
        style: {
          stroke: "none",
          fill: "#000",
          mask: "url(#" + c + ")"
        },
        transform: a
      }));
    }
    we.propTypes = {
      direction: a.a.oneOf([g, m, b, y]).isRequired,
      width: a.a.number.isRequired,
      height: a.a.number.isRequired
    };
    var Ve = ye(we);
    function xe(e) {
      var t = e.startX,
        n = e.startY,
        r = e.endX,
        i = e.endY;
      if (!(t && n && r && i)) return null;
      var a = N({
        x: t,
        y: n
      }, {
        x: r,
        y: i
      });
      return o.a.createElement("rect", {
        stroke: "#969FFF",
        strokeOpacity: .7,
        fill: "#F3F4FF",
        fillOpacity: .7,
        x: a.x,
        y: a.y,
        width: a.width,
        height: a.height,
        style: {
          pointerEvents: "none"
        }
      });
    }
    function Pe() {
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("path", {
        d: "M10.07,14.27C10.57,14.03 11.16,14.25 11.4,14.75L13.7,19.74L15.5,18.89L13.19,13.91C12.95,13.41 13.17,12.81 13.67,12.58L13.95,12.5L16.25,12.05L8,5.12V15.9L9.82,14.43L10.07,14.27M13.64,21.97C13.14,22.21 12.54,22 12.31,21.5L10.13,16.76L7.62,18.78C7.45,18.92 7.24,19 7,19A1,1 0 0,1 6,18V3A1,1 0 0,1 7,2C7.24,2 7.47,2.09 7.64,2.23L7.65,2.22L19.14,11.86C19.57,12.22 19.62,12.85 19.27,13.27C19.12,13.45 18.91,13.57 18.7,13.61L15.54,14.23L17.74,18.96C18,19.46 17.76,20.05 17.26,20.28L13.64,21.97Z"
      }));
    }
    function Me() {
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("path", {
        d: "M13,6V11H18V7.75L22.25,12L18,16.25V13H13V18H16.25L12,22.25L7.75,18H11V13H6V16.25L1.75,12L6,7.75V11H11V6H7.75L12,1.75L16.25,6H13Z"
      }));
    }
    function Ee() {
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("g", null, o.a.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      }), o.a.createElement("path", {
        d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
      })));
    }
    function je() {
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
      }));
    }
    function ke() {
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("path", {
        d: "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
      }));
    }
    xe.propTypes = {
      startX: a.a.number.isRequired,
      startY: a.a.number.isRequired,
      endX: a.a.number.isRequired,
      endY: a.a.number.isRequired
    };
    var Se = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }();
    var Te = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var n = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.state = {
            hover: !1
          }, n;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, o.a.Component), Se(t, [{
          key: "change",
          value: function value(e) {
            switch (e.preventDefault(), e.stopPropagation(), e.type) {
              case "mouseenter":
              case "touchstart":
                this.setState({
                  hover: !0
                });
                break;
              case "mouseleave":
              case "touchend":
              case "touchcancel":
                this.setState({
                  hover: !1
                });
            }
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = {
                display: "block",
                width: "24px",
                height: "24px",
                margin: [g, b].indexOf(this.props.toolbarPosition) >= 0 ? "2px 1px" : "1px 2px",
                color: this.props.active || this.state.hover ? "#1CA6FC" : "#FFF",
                transition: "color 200ms ease",
                background: "none",
                padding: "0px",
                border: "0px",
                outline: "0px",
                cursor: "pointer"
              };
            return o.a.createElement("button", {
              onMouseEnter: function onMouseEnter(t) {
                return e.change(t);
              },
              onMouseLeave: function onMouseLeave(t) {
                return e.change(t);
              },
              onTouchStart: function onTouchStart(t) {
                e.change(t), e.props.onClick(t);
              },
              onTouchEnd: function onTouchEnd(t) {
                return e.change(t);
              },
              onTouchCancel: function onTouchCancel(t) {
                return e.change(t);
              },
              onClick: this.props.onClick,
              style: t,
              title: this.props.title,
              name: this.props.name,
              role: "button",
              type: "button"
            }, this.props.children);
          }
        }]), t;
      }(),
      _e = Te;
    function Ce(e) {
      var t = e.tool,
        n = e.value,
        r = e.onChangeValue,
        i = e.onChangeTool,
        a = e.position,
        u = e.SVGAlignX,
        c = e.SVGAlignY,
        l = function l(e, t) {
          i(t), e.stopPropagation(), e.preventDefault();
        },
        s = [g, b].indexOf(a) >= 0,
        f = {
          position: "absolute",
          transform: [g, b].indexOf(a) >= 0 ? "translate(-50%, 0px)" : "none",
          top: [y, m, g].indexOf(a) >= 0 ? "5px" : "unset",
          left: [g, b].indexOf(a) >= 0 ? "50%" : y === a ? "5px" : "unset",
          right: [m].indexOf(a) >= 0 ? "5px" : "unset",
          bottom: [b].indexOf(a) >= 0 ? "5px" : "unset",
          backgroundColor: "rgba(19, 20, 22, 0.90)",
          borderRadius: "2px",
          display: "flex",
          flexDirection: s ? "row" : "column",
          padding: s ? "1px 2px" : "2px 1px"
        };
      return o.a.createElement("div", {
        style: f,
        role: "toolbar"
      }, o.a.createElement(_e, {
        toolbarPosition: a,
        active: t === h,
        name: "unselect-tools",
        title: "Selection",
        onClick: function onClick(e) {
          return l(e, h);
        }
      }, o.a.createElement(Pe, null)), o.a.createElement(_e, {
        toolbarPosition: a,
        active: t === d,
        name: "select-tool-pan",
        title: "Pan",
        onClick: function onClick(e) {
          return l(e, d);
        }
      }, o.a.createElement(Me, null)), o.a.createElement(_e, {
        toolbarPosition: a,
        active: t === p,
        name: "select-tool-zoom-in",
        title: "Zoom in",
        onClick: function onClick(e) {
          return l(e, p);
        }
      }, o.a.createElement(Ee, null)), o.a.createElement(_e, {
        toolbarPosition: a,
        active: t === v,
        name: "select-tool-zoom-out",
        title: "Zoom out",
        onClick: function onClick(e) {
          return l(e, v);
        }
      }, o.a.createElement(je, null)), o.a.createElement(_e, {
        toolbarPosition: a,
        active: !1,
        name: "fit-to-viewer",
        title: "Fit to viewer",
        onClick: function onClick(e) {
          return function (e) {
            r($(n, u, c)), e.stopPropagation(), e.preventDefault();
          }(e);
        }
      }, o.a.createElement(ke, null)));
    }
    function Re(e) {
      var t = e.open,
        n = 0;
      switch (e.position) {
        case y:
          n = t ? "rotate(225, 12, 13)" : "rotate(45, 12, 13)";
          break;
        case m:
          n = n = t ? "rotate(135, 12, 13)" : "rotate(-45, 12, 13)";
      }
      return o.a.createElement("svg", {
        width: 24,
        height: 24,
        stroke: "currentColor"
      }, o.a.createElement("g", {
        transform: n
      }, o.a.createElement("path", {
        fill: "#000000",
        d: "M7.41,15.41L12,10.83L16.59,15.41L18,14L12,8L6,14L7.41,15.41Z"
      })));
    }
    function Fe(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function Ge(e) {
      var t,
        n = e.value,
        r = e.onChangeValue,
        i = e.position,
        a = (Fe(t = {
          width: "24px",
          height: "24px",
          display: "block",
          position: "absolute",
          bottom: 0
        }, i === y ? "left" : "right", "0px"), Fe(t, "background", "rgba(19, 20, 22, 0.901961)"), Fe(t, "border", 0), Fe(t, "padding", 0), Fe(t, "outline", 0), Fe(t, "color", "#fff"), t),
        u = n.miniatureOpen ? he : fe;
      return o.a.createElement("button", {
        role: "button",
        type: "button",
        style: a,
        onClick: function onClick(e) {
          return r(u(n));
        }
      }, o.a.createElement(Re, {
        open: n.miniatureOpen,
        position: i
      }));
    }
    Te.propTypes = {
      title: a.a.string.isRequired,
      name: a.a.string.isRequired,
      toolbarPosition: a.a.string.isRequired,
      onClick: a.a.func.isRequired,
      active: a.a.bool.isRequired
    }, Ce.propTypes = {
      position: a.a.oneOf([g, m, b, y]).isRequired,
      tool: a.a.string.isRequired,
      value: a.a.object.isRequired,
      onChangeValue: a.a.func.isRequired,
      onChangeTool: a.a.func.isRequired,
      SVGAlignX: a.a.oneOf([V, x, P]),
      SVGAlignY: a.a.oneOf([V, M, E])
    }, Ce.defaultProps = {
      SVGAlignX: x,
      SVGAlignY: M
    }, Re.propTypes = {
      open: a.a.bool.isRequired,
      position: a.a.oneOf([m, y]).isRequired
    }, Ge.propTypes = {
      value: a.a.object.isRequired,
      onChangeValue: a.a.func.isRequired,
      position: a.a.oneOf([m, y]).isRequired
    };
    var Ye = "react-svg-pan-zoom_miniature";
    function De(e) {
      var t = e.SVGWidth,
        n = e.SVGHeight,
        r = e.x1,
        i = e.y1,
        a = e.x2,
        u = e.y2,
        c = (e.zoomToFit, e._uid),
        l = Ye + "_mask_" + c;
      return o.a.createElement("g", null, o.a.createElement("defs", null, o.a.createElement("mask", {
        id: l
      }, o.a.createElement("rect", {
        x: "0",
        y: "0",
        width: t,
        height: n,
        fill: "#ffffff"
      }), o.a.createElement("rect", {
        x: r,
        y: i,
        width: a - r,
        height: u - i
      }))), o.a.createElement("rect", {
        x: "0",
        y: "0",
        width: t,
        height: n,
        style: {
          stroke: "none",
          fill: "#000",
          mask: "url(#" + l + ")",
          opacity: .4
        }
      }));
    }
    De.propTypes = {
      SVGWidth: a.a.number.isRequired,
      SVGHeight: a.a.number.isRequired,
      x1: a.a.number.isRequired,
      y1: a.a.number.isRequired,
      x2: a.a.number.isRequired,
      y2: a.a.number.isRequired,
      zoomToFit: a.a.number.isRequired
    };
    var Xe = ye(De),
      qe = function () {
        return function (e, t) {
          if (Array.isArray(e)) return e;
          if (Symbol.iterator in Object(e)) return function (e, t) {
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (var a, u = e[Symbol.iterator](); !(r = (a = u.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                !r && u.return && u.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }(e, t);
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
      }();
    function Le(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    Math.min, Math.max;
    function Ae(e) {
      var t,
        n = e.value,
        r = e.onChangeValue,
        i = e.position,
        a = e.children,
        c = e.background,
        l = e.SVGBackground,
        s = e.width,
        f = e.height,
        h = n.SVGWidth,
        d = n.SVGHeight,
        p = n.viewerWidth,
        v = n.viewerHeight,
        g = d / h,
        m = g >= 1 ? f / d : s / h,
        b = Object(u.applyToPoints)(Object(u.inverse)(n), [{
          x: 0,
          y: 0
        }, {
          x: p,
          y: v
        }]),
        O = qe(b, 2),
        w = O[0],
        V = w.x,
        x = w.y,
        P = O[1],
        M = P.x,
        E = P.y,
        j = void 0,
        k = void 0;
      n.miniatureOpen ? (j = s, k = f) : (j = 24, k = 24);
      var S = (Le(t = {
          position: "absolute",
          overflow: "hidden",
          outline: "1px solid rgba(19, 20, 22, 0.90)",
          transition: "width 200ms ease, height 200ms ease, bottom 200ms ease",
          width: j + "px",
          height: k + "px",
          bottom: "6px"
        }, i === y ? "left" : "right", "6px"), Le(t, "background", c), t),
        T = g >= 1 ? "translate(" + (s - h * m) / 2 + ", 0)" : "translate(0, " + (f - d * m) / 2 + ")";
      return o.a.createElement("div", {
        role: "navigation",
        style: S
      }, o.a.createElement("svg", {
        width: s,
        height: f,
        style: {
          pointerEvents: "none"
        }
      }, o.a.createElement("g", {
        transform: T
      }, o.a.createElement("g", {
        transform: "scale(" + m + ", " + m + ")"
      }, o.a.createElement("rect", {
        fill: l,
        x: 0,
        y: 0,
        width: n.SVGWidth,
        height: n.SVGHeight
      }), a, o.a.createElement(Xe, {
        SVGWidth: h,
        SVGHeight: d,
        x1: V,
        y1: x,
        x2: M,
        y2: E,
        zoomToFit: m
      })))), o.a.createElement(Ge, {
        value: n,
        onChangeValue: r,
        position: i
      }));
    }
    Ae.propTypes = {
      position: a.a.oneOf([m, y]).isRequired,
      value: a.a.object.isRequired,
      onChangeValue: a.a.func.isRequired,
      background: a.a.string.isRequired,
      SVGBackground: a.a.string.isRequired,
      width: a.a.number.isRequired
    };
    var He = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
      },
      We = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }();
    var ze = function (e) {
        function t(e, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var r = function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e, n)),
            o = r.props,
            i = o.tool,
            a = o.value,
            l = o.width,
            s = o.height,
            f = o.scaleFactorMin,
            d = o.scaleFactorMax,
            p = o.children.props,
            v = p.width,
            g = p.height;
          return r.state = {
            value: a || function (e, t, n, r, o, i) {
              return k({}, j({}, Object(u.identity)(), {
                version: 2,
                mode: c,
                focus: !1,
                pinchPointDistance: null,
                prePinchMode: null,
                viewerWidth: e,
                viewerHeight: t,
                SVGWidth: n,
                SVGHeight: r,
                scaleFactorMin: o,
                scaleFactorMax: i,
                startX: null,
                startY: null,
                endX: null,
                endY: null,
                miniatureOpen: !0,
                lastAction: null
              }));
            }(l, s, v, g, f, d),
            tool: i || h
          }, r.ViewerDOM = null, r.autoPanLoop = r.autoPanLoop.bind(r), r;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, o.a.Component), We(t, [{
          key: "componentWillReceiveProps",
          value: function value(e) {
            var t = this.getValue(),
              n = !1,
              r = t;
            t.viewerWidth === e.width && t.viewerHeight === e.height || (r = function (e, t, n) {
              return k(e, {
                viewerWidth: t,
                viewerHeight: n
              });
            }(r, e.width, e.height), n = !0);
            var o = e.children.props,
              i = o.width,
              a = o.height;
            t.SVGWidth === i && t.SVGHeight === a || (r = function (e, t, n) {
              return k(e, {
                SVGWidth: t,
                SVGHeight: n
              });
            }(r, i, a), n = !0), t.scaleFactorMin === e.scaleFactorMin && t.scaleFactorMax === e.scaleFactorMax || (r = function (e, t, n) {
              return k(e, {
                scaleFactorMin: t,
                scaleFactorMax: n
              });
            }(r, e.scaleFactorMin, e.scaleFactorMax), n = !0), n && this.setValue(r);
          }
        }, {
          key: "getValue",
          value: function value() {
            return this.props.value ? this.props.value : this.state.value;
          }
        }, {
          key: "getTool",
          value: function value() {
            return this.props.tool ? this.props.tool : this.state.tool;
          }
        }, {
          key: "getSvgStyle",
          value: function value(e) {
            var t = {
              display: "block"
            };
            return e && (t.cursor = e), (this.props.detectPinchGesture || -1 !== [d, f].indexOf(this.getTool())) && (t.touchAction = "none"), t;
          }
        }, {
          key: "setValue",
          value: function value(e) {
            var t = this.props,
              n = t.onChangeValue,
              r = t.onZoom,
              o = t.onPan;
            this.setState({
              value: e
            }), n && n(e), e.lastAction && (r && e.lastAction === O && r(e), o && e.lastAction === w && o(e));
          }
        }, {
          key: "pan",
          value: function value(e, t) {
            var n = W(this.getValue(), e, t);
            this.setValue(n);
          }
        }, {
          key: "zoom",
          value: function value(e, t, n) {
            var r = U(this.getValue(), e, t, n);
            this.setValue(r);
          }
        }, {
          key: "fitSelection",
          value: function value(e, t, n, r) {
            var o = K(this.getValue(), e, t, n, r);
            this.setValue(o);
          }
        }, {
          key: "fitToViewer",
          value: function value() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : x,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : M,
              n = $(this.getValue(), e, t);
            this.setValue(n);
          }
        }, {
          key: "zoomOnViewerCenter",
          value: function value(e) {
            var t = J(this.getValue(), e);
            this.setValue(t);
          }
        }, {
          key: "setPointOnViewerCenter",
          value: function value(e, t, n) {
            var r = _(this.getValue(), e, t, n);
            this.setValue(r);
          }
        }, {
          key: "reset",
          value: function value() {
            var e = C(this.getValue());
            this.setValue(e);
          }
        }, {
          key: "changeTool",
          value: function value(e) {
            this.setState({
              tool: e
            }), this.props.onChangeTool && this.props.onChangeTool(e);
          }
        }, {
          key: "openMiniature",
          value: function value() {
            var e = fe(this.getValue());
            this.setValue(e);
          }
        }, {
          key: "closeMiniature",
          value: function value() {
            var e = he(this.getValue());
            this.setValue(e);
          }
        }, {
          key: "handleViewerEvent",
          value: function value(e) {
            var t = this.props,
              n = this.state.value,
              r = this.ViewerDOM;
            if ([h, f].indexOf(this.getTool()) >= 0 && e.target !== r) {
              var o = {
                click: t.onClick,
                dblclick: t.onDoubleClick,
                mousemove: t.onMouseMove,
                mouseup: t.onMouseUp,
                mousedown: t.onMouseDown,
                touchstart: t.onTouchStart,
                touchmove: t.onTouchMove,
                touchend: t.onTouchEnd,
                touchcancel: t.onTouchCancel
              }[e.type];
              o && o(function (e, t, n) {
                var r = e.type;
                switch (r) {
                  case "mousemove":
                  case "mouseup":
                  case "mousedown":
                  case "click":
                  case "dblclick":
                    return new D(e, t, n);
                  case "touchstart":
                  case "touchmove":
                  case "touchend":
                  case "touchcancel":
                    return new L(e, t, n);
                  default:
                    throw new Error(r + " not supported");
                }
              }(e, n, r));
            }
          }
        }, {
          key: "autoPanLoop",
          value: function value() {
            var e = {
                x: this.state.viewerX,
                y: this.state.viewerY
              },
              t = oe(null, this.ViewerDOM, this.getTool(), this.getValue(), this.props, e);
            this.getValue() !== t && this.setValue(t), this.autoPanIsRunning && requestAnimationFrame(this.autoPanLoop);
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            var e = this.props,
              t = this.state;
            e.onChangeValue && e.onChangeValue(t.value), this.autoPanIsRunning = !0, requestAnimationFrame(this.autoPanLoop);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.autoPanIsRunning = !1;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              n = this.state,
              r = n.viewerX,
              i = n.viewerY,
              a = this.getTool(),
              O = this.getValue(),
              w = t.customToolbar,
              V = t.customMiniature,
              x = a === f && O.mode === l && O.startX !== O.endX && O.startY !== O.endY,
              P = void 0;
            a === d && (P = pe(O.mode === l ? "grabbing" : "grab")), a === p && (P = pe("zoom-in")), a === v && (P = pe("zoom-out")), x && (P = pe("grabbing"));
            var M = [d, p, v].indexOf(a) >= 0;
            return M = M || x, o.a.createElement("div", {
              style: He({
                position: "relative",
                width: O.viewerWidth,
                height: O.viewerHeight
              }, t.style),
              className: this.props.className
            }, o.a.createElement("svg", {
              ref: function ref(t) {
                return e.ViewerDOM = t;
              },
              width: O.viewerWidth,
              height: O.viewerHeight,
              style: this.getSvgStyle(P),
              onMouseDown: function onMouseDown(t) {
                var n = ee(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onMouseMove: function onMouseMove(t) {
                var n = e.ViewerDOM.getBoundingClientRect(),
                  r = n.left,
                  o = n.top,
                  i = t.clientX - Math.round(r),
                  a = t.clientY - Math.round(o),
                  u = te(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props, {
                    x: i,
                    y: a
                  });
                e.getValue() !== u && e.setValue(u), e.setState({
                  viewerX: i,
                  viewerY: a
                }), e.handleViewerEvent(t);
              },
              onMouseUp: function onMouseUp(t) {
                var n = ne(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onClick: function onClick(t) {
                e.handleViewerEvent(t);
              },
              onDoubleClick: function onDoubleClick(t) {
                var n = function (e, t, n, r, o) {
                  var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                    a = void 0,
                    u = void 0;
                  if (i) a = i.x, u = i.y;else {
                    var c = t.getBoundingClientRect(),
                      l = c.left,
                      s = c.top;
                    a = e.clientX - Math.round(l), u = e.clientY - Math.round(s);
                  }
                  var h = r;
                  switch (n) {
                    case f:
                      if (!o.disableDoubleClickZoomWithToolAuto) {
                        var d = S(r, a, u),
                          p = o.modifierKeys.reduce(function (t, n) {
                            return t || e.getModifierState(n);
                          }, !1) ? 1 / o.scaleFactor : o.scaleFactor;
                        h = U(r, d.x, d.y, p);
                      }
                      break;
                    default:
                      return r;
                  }
                  return e.preventDefault(), h;
                }(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onWheel: function onWheel(t) {
                var n = function (e, t, n, r, o) {
                  var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null,
                    a = void 0,
                    u = void 0;
                  if (i) a = i.x, u = i.y;else {
                    var c = t.getBoundingClientRect(),
                      l = c.left,
                      s = c.top;
                    a = e.clientX - Math.round(l), u = e.clientY - Math.round(s);
                  }
                  if (!o.detectWheel) return r;
                  var f = function (e, t, n, r, o) {
                      return r + (o - r) * (e - t) / (n - t);
                    }(Math.max(-1, Math.min(1, e.deltaY)), -1, 1, o.scaleFactorOnWheel, 1 / o.scaleFactorOnWheel),
                    h = S(r, a, u),
                    d = U(r, h.x, h.y, f);
                  return e.preventDefault(), d;
                }(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n);
              },
              onMouseEnter: function onMouseEnter(t) {
                if (!("ontouchstart" in window || navigator.maxTouchPoints)) {
                  var n = re(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                  e.getValue() !== n && e.setValue(n);
                }
              },
              onMouseLeave: function onMouseLeave(t) {
                var n = re(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n);
              },
              onTouchStart: function onTouchStart(t) {
                var n = function (e, t, n, r, o) {
                  if (ce(e, o)) return ue(e, t, 0, r);
                  if (1 !== e.touches.length) {
                    if ([l, s].indexOf(r.mode) >= 0) return R(r);
                    if ([c].indexOf(r.mode) >= 0) return r;
                  }
                  return le(e, t, n, r, o, ee);
                }(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onTouchMove: function onTouchMove(t) {
                var n = function (e, t, n, r, o) {
                  return ce(e, o) ? ue(e, t, 0, r) : [l, s].indexOf(r.mode) >= 0 ? le(e, t, n, r, o, te) : r;
                }(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onTouchEnd: function onTouchEnd(t) {
                var n = se(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              },
              onTouchCancel: function onTouchCancel(t) {
                var n = function (e, t, n, r, o) {
                  return e.stopPropagation(), e.preventDefault(), R(r);
                }(t, e.ViewerDOM, e.getTool(), e.getValue(), e.props);
                e.getValue() !== n && e.setValue(n), e.handleViewerEvent(t);
              }
            }, o.a.createElement("rect", {
              fill: t.background,
              x: 0,
              y: 0,
              width: O.viewerWidth,
              height: O.viewerHeight,
              style: {
                pointerEvents: "none"
              }
            }), o.a.createElement("g", {
              transform: Object(u.toSVG)(O),
              style: M ? {
                pointerEvents: "none"
              } : {}
            }, o.a.createElement("rect", {
              fill: this.props.SVGBackground,
              style: this.props.SVGStyle,
              x: 0,
              y: 0,
              width: O.SVGWidth,
              height: O.SVGHeight
            }), o.a.createElement("g", null, t.children.props.children)), [h, f].indexOf(a) >= 0 && t.detectAutoPan && O.focus ? o.a.createElement("g", {
              style: {
                pointerEvents: "none"
              }
            }, i <= 20 ? o.a.createElement(Ve, {
              direction: g,
              width: O.viewerWidth,
              height: O.viewerHeight
            }) : null, O.viewerWidth - r <= 20 ? o.a.createElement(Ve, {
              direction: m,
              width: O.viewerWidth,
              height: O.viewerHeight
            }) : null, O.viewerHeight - i <= 20 ? o.a.createElement(Ve, {
              direction: b,
              width: O.viewerWidth,
              height: O.viewerHeight
            }) : null, O.focus && r <= 20 ? o.a.createElement(Ve, {
              direction: y,
              width: O.viewerWidth,
              height: O.viewerHeight
            }) : null) : null, O.mode !== s ? null : o.a.createElement(xe, {
              startX: O.startX,
              startY: O.startY,
              endX: O.endX,
              endY: O.endY
            })), "none" === t.toolbarPosition ? null : o.a.createElement(w, He({
              position: t.toolbarPosition,
              value: O,
              onChangeValue: function onChangeValue(t) {
                return e.setValue(t);
              },
              tool: a,
              onChangeTool: function onChangeTool(t) {
                return e.changeTool(t);
              }
            }, this.props.toolbarProps)), "none" === t.miniaturePosition ? null : o.a.createElement(V, {
              position: t.miniaturePosition,
              value: O,
              onChangeValue: function onChangeValue(t) {
                return e.setValue(t);
              },
              SVGBackground: this.props.SVGBackground,
              background: this.props.miniatureBackground,
              width: this.props.miniatureWidth,
              height: this.props.miniatureHeight
            }, t.children.props.children));
          }
        }]), t;
      }(),
      Ne = ze;
    ze.propTypes = {
      width: a.a.number.isRequired,
      height: a.a.number.isRequired,
      background: a.a.string,
      SVGBackground: a.a.string,
      SVGStyle: a.a.object,
      value: a.a.shape({
        version: a.a.oneOf([2]).isRequired,
        mode: a.a.oneOf([c, l, s]).isRequired,
        focus: a.a.bool.isRequired,
        a: a.a.number.isRequired,
        b: a.a.number.isRequired,
        c: a.a.number.isRequired,
        d: a.a.number.isRequired,
        e: a.a.number.isRequired,
        f: a.a.number.isRequired,
        viewerWidth: a.a.number.isRequired,
        viewerHeight: a.a.number.isRequired,
        SVGWidth: a.a.number.isRequired,
        SVGHeight: a.a.number.isRequired,
        startX: a.a.number,
        startY: a.a.number,
        endX: a.a.number,
        endY: a.a.number,
        miniatureOpen: a.a.bool.isRequired
      }),
      style: a.a.object,
      className: a.a.string,
      detectWheel: a.a.bool,
      detectAutoPan: a.a.bool,
      detectPinchGesture: a.a.bool,
      toolbarPosition: a.a.oneOf(["none", g, m, b, y]),
      onChangeValue: a.a.func,
      onChangeTool: a.a.func,
      onZoom: a.a.func,
      onPan: a.a.func,
      onClick: a.a.func,
      onDoubleClick: a.a.func,
      onMouseUp: a.a.func,
      onMouseMove: a.a.func,
      onMouseDown: a.a.func,
      preventPanOutside: a.a.bool,
      scaleFactor: a.a.number,
      scaleFactorOnWheel: a.a.number,
      scaleFactorMax: a.a.number,
      scaleFactorMin: a.a.number,
      tool: a.a.oneOf([f, h, d, p, v]),
      modifierKeys: a.a.array,
      customToolbar: a.a.oneOfType([a.a.element, a.a.func]),
      miniaturePosition: a.a.oneOf(["none", m, y]),
      miniatureBackground: a.a.string,
      miniatureWidth: a.a.number,
      miniatureHeight: a.a.number,
      customMiniature: a.a.oneOfType([a.a.element, a.a.func]),
      disableDoubleClickZoomWithToolAuto: a.a.bool,
      toolbarProps: a.a.shape({
        SVGAlignX: a.a.oneOf([V, x, P]),
        SVGAlignY: a.a.oneOf([V, M, E])
      }),
      children: function children(e, t, n) {
        var r = e[t],
          i = ["svg"];
        return 1 !== o.a.Children.count(r) || -1 === i.indexOf(r.type) ? new Error("`" + n + "` should have a single child of the following types:  `" + i.join("`, `") + "`.") : r.props.hasOwnProperty("width") && r.props.hasOwnProperty("height") ? void 0 : new Error("SVG should have props `width` and `height`");
      }
    }, ze.defaultProps = {
      value: null,
      tool: null,
      style: {},
      background: "#616264",
      SVGBackground: "#fff",
      SVGStyle: {},
      detectWheel: !0,
      detectAutoPan: !0,
      detectPinchGesture: !0,
      toolbarPosition: m,
      modifierKeys: ["Alt", "Shift", "Control"],
      customToolbar: Ce,
      preventPanOutside: !0,
      scaleFactor: 1.1,
      scaleFactorOnWheel: 1.06,
      miniaturePosition: y,
      miniatureWidth: 100,
      miniatureHeight: 80,
      miniatureBackground: "#616264",
      customMiniature: Ae,
      disableZoomWithToolAuto: !1,
      onZoom: null,
      onPan: null,
      toolbarProps: {}
    }, n.d(t, "Viewer", function () {
      return Ie;
    }), n.d(t, "ReactSVGPanZoom", function () {
      return Ne;
    }), n.d(t, "Toolbar", function () {
      return Ce;
    }), n.d(t, "Miniature", function () {
      return Ae;
    }), n.d(t, "setPointOnViewerCenter", function () {
      return _;
    }), n.d(t, "reset", function () {
      return C;
    }), n.d(t, "pan", function () {
      return W;
    }), n.d(t, "zoom", function () {
      return U;
    }), n.d(t, "fitSelection", function () {
      return K;
    }), n.d(t, "fitToViewer", function () {
      return $;
    }), n.d(t, "zoomOnViewerCenter", function () {
      return J;
    }), n.d(t, "openMiniature", function () {
      return fe;
    }), n.d(t, "closeMiniature", function () {
      return he;
    }), n.d(t, "MODE_IDLE", function () {
      return c;
    }), n.d(t, "MODE_PANNING", function () {
      return l;
    }), n.d(t, "MODE_ZOOMING", function () {
      return s;
    }), n.d(t, "TOOL_AUTO", function () {
      return f;
    }), n.d(t, "TOOL_NONE", function () {
      return h;
    }), n.d(t, "TOOL_PAN", function () {
      return d;
    }), n.d(t, "TOOL_ZOOM_IN", function () {
      return p;
    }), n.d(t, "TOOL_ZOOM_OUT", function () {
      return v;
    }), n.d(t, "POSITION_NONE", function () {
      return "none";
    }), n.d(t, "POSITION_TOP", function () {
      return g;
    }), n.d(t, "POSITION_RIGHT", function () {
      return m;
    }), n.d(t, "POSITION_BOTTOM", function () {
      return b;
    }), n.d(t, "POSITION_LEFT", function () {
      return y;
    }), n.d(t, "ACTION_ZOOM", function () {
      return O;
    }), n.d(t, "ACTION_PAN", function () {
      return w;
    }), n.d(t, "ALIGN_CENTER", function () {
      return V;
    }), n.d(t, "ALIGN_LEFT", function () {
      return x;
    }), n.d(t, "ALIGN_RIGHT", function () {
      return P;
    }), n.d(t, "ALIGN_TOP", function () {
      return M;
    }), n.d(t, "ALIGN_BOTTOM", function () {
      return E;
    });
    var Ie = function Ie() {
      return console.error("HEY! You are trying to use an older version of ReactSVGPanZoom. Read here https://github.com/chrvadala/react-svg-pan-zoom/blob/master/docs/migrate-from-v1-to-v2.md"), null;
    };
  }]);
});